export default () => {
  let date = new Date();

  const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, "0");

  return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
};
